import createLucideIcon from '../createLucideIcon';

const ArrowDownCircle = createLucideIcon('ArrowDownCircleIcon', [
  ['circle', { cx: '12', cy: '12', r: '10', key: '1mglay' }],
  ['polyline', { points: '8 12 12 16 16 12', key: '14qdon' }],
  ['line', { x1: '12', y1: '8', x2: '12', y2: '16', key: '55jlg' }],
]);

export default ArrowDownCircle;
